<!-- 個人資料 -->
<template>
  <section v-if="isShow">
    <h2
      :class="$style.listTitle"
      class="card__title card__title--small"
    >
      個人資料
    </h2>
    <ul class="list">
      <li class="list__item item">
        <span class="title">姓名</span>
        <span class="data">{{ memberContactData.contactLastName }} {{ memberContactData.contactFirstName }}</span>
      </li>
      <li class="list__item">
        <span class="title">聯絡電話</span>
        <span class="data">{{ memberContactData.contactPhone }}</span>
      </li>
      <li class="list__item">
        <span class="title">電子信箱</span>
        <span class="data">{{ memberContactData.contactEmail || memberContactData.loginAccountEmail }}</span>
      </li>
      <li class="list__item">
        <span class="title">收據寄送地址</span>
        <span class="data">{{ memberContactData.contactHomeAddress }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    memberContactData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isShow() {
      return this.currentTab === 'personalInfo';
    },
  },
};
</script>

<style lang="scss" module>
.listTitle {
  font-weight: 500;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 34px;
  padding-bottom: 1em;
}
</style>
